<template lang="pug">
hr
</template>

<script>
export default {
  name: "Separator",
  props: {
    field: Object,
  },
};
</script>

<style lang="scss" scoped>
hr {
  display: block;
  align-self: stretch;
  height: 0;
  border-top: 2px solid #adb4b9;
  width: 100%;
  background: $slate;
  flex: 0 0 auto;
  margin: 0.75rem 0 2.5rem;

  & + *:empty + &,
  & + *:empty + *:empty + &,
  & + *:empty + *:empty + *:empty + &,
  & + *:empty + *:empty + *:empty + *:empty + & {
    display: none;
  }
}
</style>